import testRide from './testRide';

/*
Mapping of event-specific text for Event container
 */
export default {
  'test-ride': testRide
};
